var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Button from '../../Buttons/Button/Button';
import Typography from '../../Styles/Typography/Typography';
const StyledButton = styled.div `
  margin-top: 2rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const Tab = (_a) => {
    var { title, children, numElems = 4, goTop = false, secondary = false } = _a, props = __rest(_a, ["title", "children", "numElems", "goTop", "secondary"]);
    const scrollTo = useRef(null);
    const [currPage, setCurrPage] = useState(1);
    const [numPages, setNumPages] = useState(0);
    useEffect(() => {
        const length = Math.ceil(children.length / numElems);
        setNumPages(length);
    }, [children, numElems]);
    const handleButton = (value) => {
        if (value === 'next') {
            setCurrPage(currPage + 1);
        }
        else
            setCurrPage(currPage - 1);
        return goTop && scrollTo.current ? scrollTo.current.scrollIntoView(goTop) : null;
    };
    return (_jsxs("div", Object.assign({ ref: scrollTo }, props, { children: [_jsx(Typography, Object.assign({ size: "title", color: secondary ? 'secondary' : 'main' }, { children: title })), _jsx("div", { children: children
                    ? children.slice((currPage - 1) * numElems, currPage * numElems)
                    : null }), _jsxs(StyledButton, { children: [_jsx(Button, { text: "Prev", onClick: () => handleButton('prev'), isDisabled: currPage === 1, secondary: secondary }), _jsx(Button, { text: "Next", onClick: () => handleButton('next'), isDisabled: currPage === numPages, secondary: secondary })] })] })));
};
export default Tab;
